'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUniqueId = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview 键值相关
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */


var _index = require('../type/index');

// 参考借鉴 https://github.com/lodash/lodash/blob/master/uniqueId.js
// 计数存储
var idCounter = {};

/**
 * 获取唯一id方法
 * @param {String} [prefix] id前缀
 * @return {String} 生成的ID
 */
var getUniqueId = exports.getUniqueId = function getUniqueId() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '$spaui-id$';

    if (!idCounter[prefix]) {
        idCounter[prefix] = 0;
    }

    var id = ++idCounter[prefix];
    var result = '' + (prefix + '_' + id);

    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window && (0, _index.isFunction)(window.createSPAUIComponentId)) {
        result = window.createSPAUIComponentId(result);
    }

    return result;
};

exports.default = {
    getUniqueId: getUniqueId
};